<div class="title" style="position: relative;">
  <i class="fal fa-times-circle cancelX" mat-button cdkFocusInitial (click)="onCancelClick()"></i>
  </div>

  <div class="dialog-content">
    <div [innerHTML]="dataSource"></div>
  </div>

  <mat-dialog-actions >
    <button matButton (click)="onBackClick()" class="primary-button">{{ 'Yes, Go back' | i18next }}</button>
    <button matButton (click)="onCancelClick()" class="secondary-button">{{ 'No, continue editing' | i18next }}</button>
  </mat-dialog-actions>
